
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3XIdt", function(module, exports) {

$parcel$export(module.exports, "indexOf", function () { return $69a3aae1c6961854$export$305f7d4e9d4624f2; });
$parcel$export(module.exports, "MotionContainer", function () { return $69a3aae1c6961854$export$4dd9dde56f290330; });
/* motion-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $69a3aae1c6961854$var$slideUpKeyframes = null;
const $69a3aae1c6961854$var$slideDownKeyframes = null;
const $69a3aae1c6961854$var$slideRightKeyframes = null;
const $69a3aae1c6961854$var$slideLeftKeyframes = null;
function $69a3aae1c6961854$export$305f7d4e9d4624f2(collection, predicate) {
    for(let i = 0; i < collection.length; i++){
        const item = collection[i];
        if (predicate(item)) return i;
    }
    return -1;
}
const $69a3aae1c6961854$export$4dd9dde56f290330 = ({ direction: direction = "up", children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            direction === "left" && "",
            direction === "left" && "_j7hq1o8z",
            direction === "right" && "",
            direction === "right" && "_j7hq196r",
            direction === "up" && "",
            direction === "up" && "_j7hq1jfd",
            direction === "down" && "",
            direction === "down" && "_j7hq1hlw",
            "_5sag1doz"
        ]),
        children: children
    });
};

});

parcelRegister("hbBKK", function(module, exports) {

$parcel$export(module.exports, "SubnavLayout", function () { return $2e85c12ff42be9ff$export$8a5d25b4588f0295; });
$parcel$export(module.exports, "GlobalNavProvider", function () { return $2e85c12ff42be9ff$export$2e4075f1b160db09; });
$parcel$export(module.exports, "useGlobalNavContext", function () { return $2e85c12ff42be9ff$export$65ce4fa28f5f4cfa; });
$parcel$export(module.exports, "DivOnHoverExit", function () { return $2e85c12ff42be9ff$export$801171e56642f10e; });
$parcel$export(module.exports, "default", function () { return $2e85c12ff42be9ff$export$2e2bcd8739ae039; });
/* nav-links-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $5ohHq = parcelRequire("5ohHq");

var $3XIdt = parcelRequire("3XIdt");

var $6LAyF = parcelRequire("6LAyF");

var $5fSQO = parcelRequire("5fSQO");
const $2e85c12ff42be9ff$var$fadeOutOverlayKeyFrames = null;
const $2e85c12ff42be9ff$var$fadeOutKeyframes = null;
const $2e85c12ff42be9ff$var$fadeOutOverlayAnimation = null;
const $2e85c12ff42be9ff$var$fadeOutAnimation = null;
const $2e85c12ff42be9ff$var$fadeInOverlayKeyframes = null;
const $2e85c12ff42be9ff$var$fadeInKeyframes = null;
const $2e85c12ff42be9ff$var$fadeInOverlayAnimation = null;
const $2e85c12ff42be9ff$var$fadeInAnimation = null;
const $2e85c12ff42be9ff$var$displayBlock = null;
const $2e85c12ff42be9ff$var$DropdownContentStyle = null;
const $2e85c12ff42be9ff$var$DropdownContentStyleGlobalNav = null;
const $2e85c12ff42be9ff$var$listContainer = null;
var $2e85c12ff42be9ff$export$8a5d25b4588f0295;
(function(SubnavLayout) {
    SubnavLayout[SubnavLayout["Product"] = 4] = "Product";
    SubnavLayout[SubnavLayout["Teams"] = 3] = "Teams";
    SubnavLayout[SubnavLayout["WhyAtlassian"] = 4] = "WhyAtlassian";
    SubnavLayout[SubnavLayout["Resources"] = 4] = "Resources";
    SubnavLayout[SubnavLayout["Solutions"] = 4] = "Solutions";
})($2e85c12ff42be9ff$export$8a5d25b4588f0295 || ($2e85c12ff42be9ff$export$8a5d25b4588f0295 = {}));
function $2e85c12ff42be9ff$var$layoutToWidth(layout) {
    switch(layout){
        case 4:
            return "57rem";
        case 3:
            return "43.5rem";
        default:
            return "auto";
    }
}
const $2e85c12ff42be9ff$var$GlobalNavContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $2e85c12ff42be9ff$export$2e4075f1b160db09 = ({ globalNavItemKeys: globalNavItemKeys, children: children })=>{
    const { forcedNavKey: forcedNavKey, isForcingNav: isForcingNav } = (0, $6LAyF.useForcedNav)();
    const [dropdownRefCurrentNode, setDropdownRefCurrent] = (0, $iSvIT.useState)(null);
    const [isLoggedInUserProfileDropdownOpen, setIsLoggedInUserProfileDropdownOpen] = (0, $iSvIT.useState)(false); // using callback ref to set the isGlobalNavDropdownOpen state when dropdownRef is updated
    const dropdownRefCallback = (0, $iSvIT.useCallback)((node)=>{
        setDropdownRefCurrent(node);
    }, []);
    const [state, dispatch] = (0, $iSvIT.useReducer)(function reducer(state, action) {
        // If we're forcing a nav item, ignore state changes (local dev only)
        if (isForcingNav && forcedNavKey) return (0, $6iHNw._)((0, $7Knp0._)({}, state), {
            current: forcedNavKey,
            prev: state.current
        });
        const prev = state.current;
        return (0, $6iHNw._)((0, $7Knp0._)({}, state), {
            current: action,
            prev: prev
        });
    }, {
        // Initialize with forced nav if present (local development only)
        current: isForcingNav && forcedNavKey ? forcedNavKey : null,
        prev: null
    });
    const { current: current, prev: prev } = state;
    const value = (0, $iSvIT.useMemo)(()=>{
        const currentIndex = (0, $3XIdt.indexOf)(globalNavItemKeys, (navItemKey)=>{
            return navItemKey === current;
        });
        const prevIndex = (0, $3XIdt.indexOf)(globalNavItemKeys, (navItemKey)=>{
            return navItemKey === prev;
        });
        const direction = prev === "exitDiv" ? "none" : currentIndex === -1 ? "down" : prevIndex === -1 ? "up" : "none";
        return {
            current: current,
            prev: prev,
            globalNavItemKeys: globalNavItemKeys,
            direction: direction,
            setCurrent: dispatch,
            dropdownRefCallback: dropdownRefCallback,
            dropdownRefCurrentNode: dropdownRefCurrentNode,
            isLoggedInUserProfileDropdownOpen: isLoggedInUserProfileDropdownOpen,
            setIsLoggedInUserProfileDropdownOpen: setIsLoggedInUserProfileDropdownOpen
        };
    }, [
        current,
        prev,
        globalNavItemKeys,
        dropdownRefCallback,
        dropdownRefCurrentNode,
        isLoggedInUserProfileDropdownOpen,
        setIsLoggedInUserProfileDropdownOpen
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($2e85c12ff42be9ff$var$GlobalNavContext.Provider, {
        value: value,
        children: children
    });
};
const $2e85c12ff42be9ff$export$65ce4fa28f5f4cfa = ()=>{
    const context = (0, $iSvIT.useContext)($2e85c12ff42be9ff$var$GlobalNavContext);
    if (!context) throw new Error("useGlobalNavContext must be used within GlobalNavProvider");
    return context;
};
const $2e85c12ff42be9ff$export$d2589e93208d8ae2 = ()=>{
    const { setCurrent: setCurrent } = $2e85c12ff42be9ff$export$65ce4fa28f5f4cfa();
    const handleMouseLeave = (0, $iSvIT.useCallback)(()=>{
        setCurrent("exitDiv");
    }, [
        setCurrent
    ]);
    return {
        handleMouseLeave: handleMouseLeave
    };
};
const $2e85c12ff42be9ff$export$801171e56642f10e = ({ children: children })=>{
    const { handleMouseLeave: handleMouseLeave } = $2e85c12ff42be9ff$export$d2589e93208d8ae2();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        onMouseLeave: handleMouseLeave,
        className: (0, $esG4f.default)([
            "_4t3i1osq"
        ]),
        children: children
    });
};
const $2e85c12ff42be9ff$var$MoreOrLess = ({ showButton: showButton, isShowingMore: isShowingMore, onClick: onClick })=>{
    const intl = (0, $f6qj2.default)();
    const visibility = showButton ? "visible" : "hidden";
    const onKeyDown = (e)=>{
        if (e.code === "Enter" || e.code === "Space") onClick();
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
        "aria-hidden": true,
        style: {
            visibility: visibility,
            position: showButton ? "initial" : "absolute"
        },
        "data-element-globalnav": isShowingMore ? "less" : "more",
        "data-element-visibility": visibility,
        "data-testid": "moreOrLess-button",
        className: (0, $esG4f.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            role: "button",
            tabIndex: 0,
            onClick: onClick,
            onKeyDown: onKeyDown,
            className: (0, $esG4f.default)([
                "_1q51u2gc _1e0c1txw _4cvr1h6o _vwz41j6v _80omtlke _30l31ep1"
            ]),
            style: {
                "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
            },
            children: isShowingMore ? /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_syaz1hap"
                ]),
                style: {
                    "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700"))
                },
                children: intl.formatMessage({
                    id: "globalNav.V2.navlink.lessMinus",
                    defaultMessage: "Less -"
                })
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                children: intl.formatMessage({
                    id: "globalNav.V2.navlink.morePlus",
                    defaultMessage: "More +"
                })
            })
        })
    });
};
const $2e85c12ff42be9ff$var$GlobalNavLinksContainer = ({ globalLinksProps: globalLinksProps, globalLinksRef: globalLinksRef, maxLinks: maxLinks = globalLinksProps.length, showMore: showMore, setShowMore: setShowMore, isSubnav: isSubnav = false })=>{
    const { current: current, setCurrent: setCurrent, dropdownRefCallback: dropdownRefCallback, prev: prev, dropdownRefCurrentNode: dropdownRefCurrentNode } = $2e85c12ff42be9ff$export$65ce4fa28f5f4cfa();
    const closedDropdownRef = (0, $iSvIT.useRef)(null);
    const handleEscKeyEvent = (0, $iSvIT.useCallback)((event)=>{
        if (event.key === "Escape") setCurrent("");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const handleClickOutside = (0, $iSvIT.useCallback)((event)=>{
        if (dropdownRefCurrentNode && !dropdownRefCurrentNode.contains(event.target)) setCurrent("");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $iSvIT.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscKeyEvent, false); // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscKeyEvent, false);
        };
    }, [
        handleEscKeyEvent,
        handleClickOutside
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (current === "exitDiv") setCurrent("");
    }, [
        current,
        setCurrent
    ]);
    const showMoreButton = maxLinks < globalLinksProps.length;
    const showMoreGridTemplateColumns = showMore ? globalLinksProps.length + 1 : maxLinks === globalLinksProps.length ? maxLinks : maxLinks + 1;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            globalLinksProps.find((globalLink)=>globalLink.globalLinksKey === current && globalLink.hasSubnav) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqsw1n9t _1e0cglyw _1bsb1osq _4t3i1osq _152tidpf _1e02idpf _rjxpidpf _u7coidpf _tzy415iw _bfhkcd5j _1pby1mrw",
                    "_1e0c1ule",
                    !prev && "",
                    !prev && "_y44vbv9d",
                    !current && "",
                    !current && "_y44v5127"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($2e85c12ff42be9ff$export$801171e56642f10e, {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _yv0enq0k _4cvr1h6o _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1osq _3l1axy5q",
                        "glob-nav-links-container-ul"
                    ]),
                    style: {
                        gridTemplateColumns: `repeat(${!isSubnav ? showMoreGridTemplateColumns : maxLinks}, max-content)`
                    },
                    ref: globalLinksRef,
                    children: [
                        globalLinksProps.map(// eslint-disable-next-line complexity
                        (globalLink, index)=>{
                            const containerPosition = globalLink.containerPosition || "initial";
                            const isVisible = globalLink.hasSubnav && globalLink.globalLinksKey === current;
                            const shouldFadeIn = isVisible && !prev;
                            const shouldShowMore = index + 1 <= maxLinks || showMore;
                            const computedLayoutNumber = globalLink === null || globalLink === void 0 ? void 0 : globalLink.layout;
                            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                                    style: {
                                        position: shouldShowMore ? containerPosition : "absolute",
                                        visibility: shouldShowMore ? "visible" : "hidden"
                                    },
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _4cvr1h6o _4t3i1osq",
                                        isSubnav && "_6rth12x7"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5fSQO.default), (0, $7Knp0._)({}, globalLink)),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            ref: isVisible ? dropdownRefCallback : closedDropdownRef,
                                            "aria-hidden": !(globalLink === null || globalLink === void 0 ? void 0 : globalLink.content),
                                            className: (0, $esG4f.default)([
                                                "_1e0cglyw _tzy4kb7n _152t88uy _1ul9ncxg _1bsb1ris _kqswstnw _1reo15vq _18m915vq _2rkoo7ao _19itglyw _16qs1641 _1f49b4wl _bfhkcd5j _v564122b _1pbyzo7u",
                                                !isSubnav && "_1e02idpf _rjxpidpf _195g1wug",
                                                shouldFadeIn && "",
                                                shouldFadeIn && "_y44v11aa",
                                                isVisible && "_1e0c1ule",
                                                !isVisible && "",
                                                !isVisible && "_y44v1d5f"
                                            ]),
                                            style: (0, $6iHNw._)((0, $7Knp0._)({
                                                width: $2e85c12ff42be9ff$var$layoutToWidth(computedLayoutNumber)
                                            }, globalLink === null || globalLink === void 0 ? void 0 : globalLink.containerStyles), {
                                                "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300")),
                                                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                            }),
                                            children: globalLink.content
                                        })
                                    ]
                                })
                            }, `${globalLink.globalLinksKey}-${index}`);
                        }),
                        !isSubnav && !!setShowMore && /*#__PURE__*/ (0, $loA2J.jsx)($2e85c12ff42be9ff$var$MoreOrLess, {
                            showButton: showMoreButton,
                            isShowingMore: showMore,
                            onClick: ()=>setShowMore((prev)=>!prev)
                        })
                    ]
                })
            })
        ]
    });
};
const $2e85c12ff42be9ff$export$534659cdeeaf0451 = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: children
    });
var $2e85c12ff42be9ff$export$2e2bcd8739ae039 = $2e85c12ff42be9ff$var$GlobalNavLinksContainer;

});
parcelRegister("6LAyF", function(module, exports) {

$parcel$export(module.exports, "useForcedNav", function () { return $4d268cd8b4852aaa$export$90ca8111a9ef44f6; });

var $iSvIT = parcelRequire("iSvIT");
const $4d268cd8b4852aaa$export$90ca8111a9ef44f6 = ()=>{
    const forcedNavKey = (0, $iSvIT.useMemo)(()=>{
        typeof window;
        return null;
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const forceNavParam = urlParams.get("forceNav");
            if (forceNavParam !== null) {
                const validNavKeys = [
                    "products",
                    "solutions",
                    "why-atlassian",
                    "resources",
                    "teams"
                ];
                if (validNavKeys.includes(forceNavParam)) return forceNavParam;
            }
        } catch (error) {
        // not found
        }
        return null;
    }, []);
    return {
        forcedNavKey: forcedNavKey,
        isForcingNav: forcedNavKey !== null
    };
};

});

parcelRegister("5fSQO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $716487c54ae2c450$export$2e2bcd8739ae039; });
/* nav-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");

var $6LAyF = parcelRequire("6LAyF");

var $hbBKK = parcelRequire("hbBKK");
const $716487c54ae2c450$var$GlobalNavLink = (props)=>{
    const { current: current, setCurrent: setCurrent } = (0, $hbBKK.useGlobalNavContext)();
    const { isForcingNav: isForcingNav, forcedNavKey: forcedNavKey } = (0, $6LAyF.useForcedNav)();
    const isCurrentOpenDropdown = current === props.globalLinksKey;
    const navLinkIsCurrentPage = props.href && globalThis.location.pathname.includes(props.href);
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const anchorLinkClassName = `glob-nav-anchor-link nav-link-anchor` + `${navLinkIsCurrentPage ? " isCurrentPage " : ""}` + `${!!isCurrentOpenDropdown && !!props.hasSubnav ? "isActive" : ""}` + `${!props.hasSubnav ? "isHoverableLink" : ""}` + `${props.isActive ? " isActive " : ""}`;
    const linkClickAction = (e)=>{
        if (props.hasSubnav) {
            e.preventDefault();
            if (isForcingNav && forcedNavKey !== props.globalLinksKey) return;
            if (isOpen) {
                setCurrent("");
                setIsOpen(false);
            } else {
                setCurrent(props.globalLinksKey);
                setIsOpen(true);
            }
        }
    };
    const rotate180deg = null;
    var _props_href, _props_productKey;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
        className: (0, $esG4f.default)([
            "_1q51u2gc _1e0c1txw _4cvr1h6o _4t3i1osq _4bfu1r31 _1hmsglyw _ajmmnqa1 _vwz41j6v _y4tixy5q _175u1ep1 _30l317la _2oz41l7b _ulmp1r31 _5rleglyw _1ogcnqa1",
            anchorLinkClassName
        ]),
        href: (_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : "#",
        onClick: linkClickAction,
        onMouseEnter: ()=>{
            if (isForcingNav && forcedNavKey !== props.globalLinksKey) return;
            setCurrent(props.globalLinksKey);
            setIsOpen(true);
        },
        "aria-label": props.linkText,
        "aria-expanded": props.hasSubnav ? !!isCurrentOpenDropdown : undefined,
        role: props.hasSubnav ? "button" : undefined,
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "headerDropdownLink",
        "data-product-key": (_props_productKey = props.productKey) !== null && _props_productKey !== void 0 ? _props_productKey : "jiraSoftware",
        style: {
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
        },
        children: [
            props.linkText,
            !!props.hasSubnav && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule _ahbqftgi _vwz4idpf _v5641doz",
                    isCurrentOpenDropdown && "_t9ec1sub",
                    "chevron-icon"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "11",
                    height: "6",
                    viewBox: "0 0 11 6",
                    fill: "none",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M9.19922 1.18176L5.19922 4.81813L1.19922 1.18176",
                        stroke: isCurrentOpenDropdown ? (0, $5ohHq.wacToken)("color.extended.blue800") : (0, $5ohHq.wacToken)("color.primary.black"),
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
};
var $716487c54ae2c450$export$2e2bcd8739ae039 = $716487c54ae2c450$var$GlobalNavLink;

});


parcelRegister("cdfGl", function(module, exports) {

$parcel$export(module.exports, "analyticsLabels", function () { return $48c502d20a280306$export$6363339a4cf0caa7; });
$parcel$export(module.exports, "useGlobalNavUserProfileClickActions", function () { return $48c502d20a280306$export$21423259c10ee0e; });
$parcel$export(module.exports, "GlobalNavUserProfile", function () { return $48c502d20a280306$export$119e15e0a961cff6; });
/* user-profile.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $g9kzu = parcelRequire("g9kzu");

var $gFK1O = parcelRequire("gFK1O");

var $9iWJ8 = parcelRequire("9iWJ8");

var $5wOn9 = parcelRequire("5wOn9");

var $fUSdi = parcelRequire("fUSdi");

var $9m6Nm = parcelRequire("9m6Nm");

var $c1VRy = parcelRequire("c1VRy");
const $48c502d20a280306$export$6363339a4cf0caa7 = {
    "JoinSiteUserDropdown.logOut": "Log out",
    "JoinSiteUserDropdown.logIn": "Sign in",
    "JoinSiteUserDropdown.joinTeam": "Find my team",
    "JoinSiteUserDropdown.profile": "Profile",
    "JoinSiteUserDropdown.switchAccount": "Switch Account",
    "JoinSiteUserDropdown.licenses": "Licenses"
};
const $48c502d20a280306$var$NEXT_PUBLIC_API_MAC_URL = "https://my.atlassian.com";
const $48c502d20a280306$var$NEXT_PUBLIC_IDENTITY_BASE_URL = "https://id.atlassian.com";
const $48c502d20a280306$var$NEXT_PUBLIC_API_PRIVATE_BASE_URL = "https://www.atlassian.com/gateway/api";
const $48c502d20a280306$var$generalSigninPromptParentDivStyle = null;
const $48c502d20a280306$export$21423259c10ee0e = ({ email: email })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const onManageLicensesClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.manage.licenses",
            label: $48c502d20a280306$export$6363339a4cf0caa7["JoinSiteUserDropdown.licenses"]
        }).fire();
        window.location.assign($48c502d20a280306$var$NEXT_PUBLIC_API_MAC_URL);
    };
    const getManageProfileUrl = (userEmail)=>{
        const applicationParam = encodeURIComponent("wac");
        const continueUrlParam = encodeURIComponent(`${$48c502d20a280306$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/manage-profile`);
        const loginHintParam = encodeURIComponent(userEmail);
        return `${$48c502d20a280306$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/login?application=${applicationParam}&continue=${continueUrlParam}&login_hint=${loginHintParam}`;
    };
    const onManageProfileClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.manage.profile",
            label: $48c502d20a280306$export$6363339a4cf0caa7["JoinSiteUserDropdown.profile"]
        }).fire();
        window.location.assign(getManageProfileUrl(email || ""));
    };
    const getLogoutUrl = ()=>{
        const continueUrl = window.location.href;
        return `${$48c502d20a280306$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/logout?continue=${encodeURIComponent(continueUrl)}`;
    };
    const onLogOutClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.logout",
            label: $48c502d20a280306$export$6363339a4cf0caa7["JoinSiteUserDropdown.logOut"]
        }).fire();
        if (window.location.hostname === "localhost") (0, $gFK1O.Cookie).writeCookie("login_user_detected", "false", 3650, true);
        window.location.assign(getLogoutUrl());
    };
    const onLogInClick = ()=>{
        const baseUrl = $48c502d20a280306$var$NEXT_PUBLIC_IDENTITY_BASE_URL;
        const stargateBaseUrl = $48c502d20a280306$var$NEXT_PUBLIC_API_PRIVATE_BASE_URL;
        let continueUrl = stargateBaseUrl + "/start/authredirect";
        const keepLandUsersOnWacExperiment = (0, $9iWJ8.getExperimentWithExposures)((0, $9iWJ8.experiments).cfind4026KeepLandUsersOnWac); // if treatment return the new continue url, else control gets whatever normal route behavior is
        if (keepLandUsersOnWacExperiment.type == "enrolled" && keepLandUsersOnWacExperiment.value) continueUrl = stargateBaseUrl + `/start/authredirect?continue=${window.location.href}`;
         // Check if the user is on localhost and set the cookie for the domain localhost
        if (window.location.hostname === "localhost") (0, $gFK1O.Cookie).writeCookie("login_user_detected", "true", 3650, true);
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.login",
            label: $48c502d20a280306$export$6363339a4cf0caa7["JoinSiteUserDropdown.logIn"]
        }).fire();
        window.location.assign(`${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`);
    };
    const getSwitchAccountURL = (continueUrlParam)=>{
        const continueUrl = continueUrlParam ? continueUrlParam : window.location.href;
        return `${$48c502d20a280306$var$NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(continueUrl)}`;
    };
    const onSwitchAccountClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.switchAccount",
            label: $48c502d20a280306$export$6363339a4cf0caa7["JoinSiteUserDropdown.switchAccount"]
        }).fire();
        window.location.assign(getSwitchAccountURL());
    };
    return {
        onSwitchAccountClick: onSwitchAccountClick,
        onManageProfileClick: onManageProfileClick,
        onManageLicensesClick: onManageLicensesClick,
        onLogOutClick: onLogOutClick,
        onLogInClick: onLogInClick
    };
};
const $48c502d20a280306$export$119e15e0a961cff6 = ({ isUseNewLoggedInUserDropdown: isUseNewLoggedInUserDropdown = false, isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig = false, setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const { onSwitchAccountClick: onSwitchAccountClick, onManageProfileClick: onManageProfileClick, onManageLicensesClick: onManageLicensesClick, onLogOutClick: onLogOutClick, onLogInClick: onLogInClick } = $48c502d20a280306$export$21423259c10ee0e({
        email: userInfo.email
    });
    if (userInfo.requestInProgress) return 0, $c1VRy.LoadingSpinner;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            isUseGeneralSigninPromptConfig && "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: userInfo.isUserLoggedIn ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $fUSdi.LoggedInUser), {
            userInfo: {
                displayName: userInfo.name || "",
                email: userInfo.email || "",
                avatar: userInfo.picture || ""
            },
            onSwitchAccountClick: onSwitchAccountClick,
            onManageProfileClick: onManageProfileClick,
            onManageLicensesClick: onManageLicensesClick,
            onLogOutClick: onLogOutClick,
            isUseNewLoggedInUserDropdown: isUseNewLoggedInUserDropdown
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $9m6Nm.LoggedOutUser), {
            onLogInClick: onLogInClick,
            isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig,
            setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig
        })
    });
};

});
parcelRegister("fUSdi", function(module, exports) {

$parcel$export(module.exports, "LoggedInUser", function () { return $ed8f2f2c4c47d544$export$5effdf6804a02eac; });
/* loggedin-user-view.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $6IiXU = parcelRequire("6IiXU");

var $5ohHq = parcelRequire("5ohHq");

var $hbBKK = parcelRequire("hbBKK");

var $awNxQ = parcelRequire("awNxQ");

var $kBVJZ = parcelRequire("kBVJZ");

var $c1VRy = parcelRequire("c1VRy");

var $jM6Lt = parcelRequire("jM6Lt");

const $ed8f2f2c4c47d544$var$DropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(()=>// @ts-ignore
    (parcelRequire("iWtv6")).then(({ DropdownMenu: DropdownMenu })=>({
            default: DropdownMenu
        })));

const $ed8f2f2c4c47d544$var$DropdownItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(()=>(parcelRequire("lXsUb")).then(({ DropdownItem: DropdownItem })=>({
            default: DropdownItem
        })));

const $ed8f2f2c4c47d544$var$DropdownItemGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(()=>(parcelRequire("lXsUb")).then(({ DropdownItemGroup: DropdownItemGroup })=>({
            default: DropdownItemGroup
        })));
const $ed8f2f2c4c47d544$export$94d1de242beb0fe2 = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick })=>// @ts-ignore
    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownMenu, {
        shouldRenderToParent: true,
        spacing: "compact",
        placement: "bottom-end" // @ts-ignore
        ,
        trigger: (_param)=>/*#__PURE__*/ {
            var { triggerRef: triggerRef } = _param, props = (0, $akGnX._)(_param, [
                "triggerRef"
            ]);
            return (0, $loA2J.jsx)((0, $6IiXU.default), (0, $6iHNw._)((0, $7Knp0._)({
                className: (0, $esG4f.default)([
                    "_1yt4ze3t _1bsbv47k _4t3iv47k _2rko1ssb",
                    "avatar-button"
                ])
            }, props), {
                iconBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBVJZ.WACAvatar), {
                    name: userInfo.displayName,
                    src: userInfo.avatar,
                    size: "small",
                    showTooltip: true
                }),
                ref: triggerRef,
                style: {
                    backgroundColor: "transparent"
                }
            }));
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "global-nav-user-profile-container-user-loggedin",
            className: (0, $esG4f.default)([
                "_ect4q6fz _1bsbr0r7 _vwz4utpp _18e6b3bt _1umoze3t _1rzf1wug _3n48q6fz _by5nutpp"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)($ed8f2f2c4c47d544$var$DropdownItemGroup, {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        isDisabled: true,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jM6Lt.UserDetailsCard), {
                            name: userInfo.displayName,
                            src: userInfo.avatar,
                            email: userInfo.email,
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onSwitchAccountClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).switchAccount))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onManageProfileClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).profile))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onManageLicensesClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).licenses))
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onLogOutClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).logOut))
                    })
                ]
            })
        })
    });
const $ed8f2f2c4c47d544$export$155fa01529662abd = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick })=>{
    const [isNameLengthExceedLimit, setIsNameLengthExceedLimit] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    const [displayedName, setDisplayedName] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(()=>{
        var _userInfo_displayName;
        return (_userInfo_displayName = userInfo.displayName) !== null && _userInfo_displayName !== void 0 ? _userInfo_displayName : "";
    });
    const { setIsLoggedInUserProfileDropdownOpen: setIsLoggedInUserProfileDropdownOpen } = (0, $hbBKK.useGlobalNavContext)();
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>{
        if (userInfo.displayName.length > 15) {
            setIsNameLengthExceedLimit(true);
            setDisplayedName(userInfo.displayName.slice(0, 15));
        }
    }, [
        userInfo.displayName
    ]);
    return(// @ts-ignore
    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownMenu, {
        shouldRenderToParent: true,
        placement: "bottom-end",
        onOpenChange: (attrs)=>{
            setIsLoggedInUserProfileDropdownOpen(attrs.isOpen);
        },
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger: (_param)=>/*#__PURE__*/ {
            var { triggerRef: triggerRef } = _param, props = (0, $akGnX._)(_param, [
                "triggerRef"
            ]);
            return (0, $loA2J.jsx)((0, $6IiXU.default), (0, $6iHNw._)((0, $7Knp0._)({
                className: "avatar-button"
            }, props), {
                iconBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBVJZ.WACAvatar), {
                    name: userInfo.displayName,
                    src: userInfo.avatar,
                    size: "medium",
                    showTooltip: true
                }),
                ref: triggerRef,
                style: {
                    backgroundColor: "transparent",
                    padding: "0px",
                    fontSize: ".875rem",
                    fontWeight: "600",
                    alignItems: "center",
                    lineHeight: "1",
                    gap: "4px"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                    "aria-hidden": "true",
                    children: [
                        displayedName,
                        isNameLengthExceedLimit ? "..." : ""
                    ]
                })
            }));
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "global-nav-user-profile-container-user-loggedin",
            className: (0, $esG4f.default)([
                "_1bsbncxg _1yt41jfw _vwz4pxbi _keweze3t _d4lf1crf _1t8v1j28 _j6fnglyw _1hw6glyw"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)($ed8f2f2c4c47d544$var$DropdownItemGroup, {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _zulppxbi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        isDisabled: true,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_1wyb1crf _k48p1fw0 _1p1dangw _syaz1hlo _vwz47vkz _ect4bzd7 _1e0c1ule"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: userInfo.email
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onSwitchAccountClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_1wybdlk8 _vwz41tcg _ect4bzd7 _1e0c1ule _30l3jk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).switchAccount))
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onManageProfileClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_1wybdlk8 _vwz41tcg _ect4bzd7 _1e0c1ule _30l3jk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).profile))
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onManageLicensesClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_1wybdlk8 _vwz41tcg _ect4bzd7 _1e0c1ule _30l3jk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).licenses))
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$var$DropdownItem, {
                        onClick: onLogOutClick,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_1wybdlk8 _vwz41tcg _ect4bzd7 _1e0c1ule _30l3jk2v"
                            ]),
                            style: {
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).logOut))
                        })
                    })
                ]
            })
        })
    }));
};
const $ed8f2f2c4c47d544$export$5effdf6804a02eac = ({ userInfo: userInfo, onLogOutClick: onLogOutClick, onManageLicensesClick: onManageLicensesClick, onManageProfileClick: onManageProfileClick, onSwitchAccountClick: onSwitchAccountClick, isUseNewLoggedInUserDropdown: isUseNewLoggedInUserDropdown = false })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        fallback: (0, $c1VRy.LoadingSpinner),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "main-container",
            className: (0, $esG4f.default)([
                "_ect4q6fz"
            ]),
            children: isUseNewLoggedInUserDropdown ? /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$export$155fa01529662abd, {
                userInfo: userInfo,
                onLogOutClick: onLogOutClick,
                onManageLicensesClick: onManageLicensesClick,
                onManageProfileClick: onManageProfileClick,
                onSwitchAccountClick: onSwitchAccountClick
            }) : /*#__PURE__*/ (0, $loA2J.jsx)($ed8f2f2c4c47d544$export$94d1de242beb0fe2, {
                userInfo: userInfo,
                onLogOutClick: onLogOutClick,
                onManageLicensesClick: onManageLicensesClick,
                onManageProfileClick: onManageProfileClick,
                onSwitchAccountClick: onSwitchAccountClick
            })
        })
    });
};
const $ed8f2f2c4c47d544$var$mainContainer = null;
const $ed8f2f2c4c47d544$var$loggedInUserContainer = null;
const $ed8f2f2c4c47d544$var$updatedLoggedInUserContainer = null;
const $ed8f2f2c4c47d544$var$dropdownListStyle = null;
const $ed8f2f2c4c47d544$var$disabledItemStyle = null;
const $ed8f2f2c4c47d544$var$dropdownItemStyle = null;
const $ed8f2f2c4c47d544$var$overrideAvatarButtonStyle = null;

});
parcelRegister("awNxQ", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $c832d368a7ecaaec$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $c832d368a7ecaaec$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    logIn: {
        id: `JoinSiteUserDropdown.logIn`,
        defaultMessage: "Sign in"
    },
    logInAlternative: {
        id: `JoinSiteUserDropdown.logInAlternative`,
        defaultMessage: "Log in"
    },
    joinTeam: {
        id: `JoinSiteUserDropdown.joinTeam`,
        defaultMessage: "Find my team"
    },
    profile: {
        id: `JoinSiteUserDropdown.profile`,
        defaultMessage: "Profile"
    },
    licenses: {
        id: `JoinSiteUserDropdown.licenses`,
        defaultMessage: "Licenses"
    },
    logOut: {
        id: `JoinSiteUserDropdown.logOut`,
        defaultMessage: "Log out"
    },
    logOutTriggerText: {
        id: `JoinSiteUserDropdown.logOutTriggerText`,
        defaultMessage: "My account"
    },
    switchAccount: {
        id: `JoinSiteUserDropdown.switchAccount`,
        defaultMessage: "Switch Account"
    }
});

});

parcelRegister("kBVJZ", function(module, exports) {

$parcel$export(module.exports, "WACAvatar", function () { return $fabb0cd4eace54bb$export$c4e152e3661f6058; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $objBZ = parcelRequire("objBZ");

var $iSjV6 = parcelRequire("iSjV6");
const $fabb0cd4eace54bb$export$c4e152e3661f6058 = (props)=>{
    return props.showTooltip ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSjV6.default), {
        content: props.name,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $objBZ.default), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
            appearance: "circle"
        }))
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $objBZ.default), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        appearance: "circle"
    }));
};

});

parcelRegister("c1VRy", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", function () { return $17c47515e686e8f1$export$b08b517936747730; });

var $loA2J = parcelRequire("loA2J");

var $9gh2a = parcelRequire("9gh2a");
const $17c47515e686e8f1$export$b08b517936747730 = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
    role: "alert",
    "aria-label": "Loading",
    "data-testid": "global-nav-user-profile-container-spinner",
    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {})
});

});

parcelRegister("jM6Lt", function(module, exports) {

$parcel$export(module.exports, "UserDetailsCard", function () { return $8da5371ddc70ed04$export$23a905c82baae3c5; });
/* user-details-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $kBVJZ = parcelRequire("kBVJZ");
const $8da5371ddc70ed04$export$23a905c82baae3c5 = ({ email: email, name: name, size: size, src: src })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _1yt41pyq _1bsbr0r7 _bfhkalr3"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kBVJZ.WACAvatar), {
                name: name,
                src: src,
                size: size
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1n261q9c _ahbqu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1wybpxbi _vwz4v47k _syazu67f"
                        ]),
                        children: [
                            name,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1wybutpp _vwz4utpp _syaz1kby _o5721q9c _1reo15vq _18m915vq _1bto1l2s"
                        ]),
                        children: [
                            email,
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
const $8da5371ddc70ed04$var$userDetailsContainer = null;
const $8da5371ddc70ed04$var$userInfoContainer = null;
const $8da5371ddc70ed04$var$userNameLabel = null;
const $8da5371ddc70ed04$var$userEmailLabel = null;

});

parcelRegister("iWtv6", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9A9YW")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("fr48Q")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("3jc59"))
]).then(()=>parcelRequire("1NQko"));

});
parcelRegister("frKV3", function(module, exports) {
"use strict";

var $jhlcP = parcelRequire("jhlcP");
module.exports = $jhlcP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("jhlcP", function(module, exports) {
"use strict";
var $039f3a07df33262a$var$cachedBundles = {};
var $039f3a07df33262a$var$cachedPreloads = {};
var $039f3a07df33262a$var$cachedPrefetches = {};
function $039f3a07df33262a$var$getCache(type) {
    switch(type){
        case "preload":
            return $039f3a07df33262a$var$cachedPreloads;
        case "prefetch":
            return $039f3a07df33262a$var$cachedPrefetches;
        default:
            return $039f3a07df33262a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $039f3a07df33262a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});


parcelRegister("lXsUb", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("aJnuP")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("6sxNh")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("9A9YW")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("fr48Q")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("6KIfb"))
]).then(()=>parcelRequire("kSKvT"));

});


parcelRegister("9m6Nm", function(module, exports) {

$parcel$export(module.exports, "LoggedOutUser", function () { return $418a8dd4fc3bca84$export$8339543958fe900f; });
/* loggedout-user-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $6IiXU = parcelRequire("6IiXU");

var $8UCEs = parcelRequire("8UCEs");

var $5ohHq = parcelRequire("5ohHq");

var $hbBKK = parcelRequire("hbBKK");

var $awNxQ = parcelRequire("awNxQ");
const $418a8dd4fc3bca84$export$8339543958fe900f = ({ onLogInClick: onLogInClick, isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig = false, setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    const { dropdownRefCurrentNode: dropdownRefCurrentNode } = (0, $hbBKK.useGlobalNavContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        if (createAnalyticsEvent && isUseGeneralSigninPromptConfig) createAnalyticsEvent({
            eventName: "gwp.generalSigninPrompt.modalDisplayed",
            eventType: "ui",
            action: "displayed",
            actionSubject: "modal",
            actionSubjectId: "GeneralSigninPromptModalDisplayed"
        }).fire();
    }, [
        createAnalyticsEvent,
        isUseGeneralSigninPromptConfig
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                    appearance: "subtle",
                    name: "sign-in",
                    onClick: onLogInClick,
                    role: "link",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_d0altlke"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_ect4q6fz _1wybpxbi _syaz1ep1"
                                ]),
                                style: {
                                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                                },
                                children: isUseGeneralSigninPromptConfig ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).logInAlternative)) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $awNxQ.messages).logIn))
                            })
                        })
                    })
                })
            }),
            !dropdownRefCurrentNode && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8UCEs.GeneralSigninPrompt), {
                isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig,
                setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig
            })
        ]
    });
};
const $418a8dd4fc3bca84$var$rootContainer = null;
const $418a8dd4fc3bca84$var$triggerContainer = null;
const $418a8dd4fc3bca84$var$titleLabel = null;

});
parcelRegister("8UCEs", function(module, exports) {

$parcel$export(module.exports, "GeneralSigninPrompt", function () { return $a7010b2471d28280$export$6b94dec1be0ad04b; });
/* general-signin-prompt.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $f448m = parcelRequire("f448m");

var $5ohHq = parcelRequire("5ohHq");

var $gHCzX = parcelRequire("gHCzX");

var $cvyIB = parcelRequire("cvyIB");

var $81Ns6 = parcelRequire("81Ns6");

var $c6z6g = parcelRequire("c6z6g");
const $a7010b2471d28280$var$signinPromptDropdownMenuStyles = null;
const $a7010b2471d28280$var$closeIconStyles = null;
const $a7010b2471d28280$var$headerTextStyles = null;
const $a7010b2471d28280$var$headerStyles = null;
const $a7010b2471d28280$var$subHeaderStyles = null;
const $a7010b2471d28280$var$closeIconWrapperStyles = null;
const $a7010b2471d28280$var$darkGrayTextCss = null;
const $a7010b2471d28280$var$accountCreationContainerStyles = null; // Components
const $a7010b2471d28280$export$39e854c35d636741 = ({ setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleCloseButton = ()=>{
        const consecutiveXClicksItem = "general_signin_prompt_x_clicks";
        const lastVisitTimestampItem = "general_signin_prompt_last_visit_timestamp";
        const currentXClicks = Number(localStorage.getItem(consecutiveXClicksItem) || "0");
        localStorage.setItem(consecutiveXClicksItem, String(currentXClicks + 1));
        localStorage.setItem(lastVisitTimestampItem, new Date().toISOString());
        createAnalyticsEvent({
            eventName: "gwp.generalSigninPrompt.dismissed",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "GeneralSigninPromptCloseIcon"
        }).fire();
        setIsUseGeneralSigninPromptConfig === null || setIsUseGeneralSigninPromptConfig === void 0 ? void 0 : setIsUseGeneralSigninPromptConfig(false);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_zxndglyw _1e0c1ule _kqswstnw _152toahv _1yt41ejb _2rkou2gc _bfhkcd5j _1pfhxy5q _1bsb1edt _p12f8ora _16qs1cd0 _1pbyzyxb _y44v1p04 _wjvazwfg",
            "general-signin-prompt-dropdown-menu"
        ]),
        "data-testid": "genearl-signin-prompt-dropdown-menu",
        "aria-label": "global-nav-signin-prompt-dropdown-menu",
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _rjxp1ejb _152t1ejb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        handleCloseButton();
                    },
                    "aria-label": "general-signin-prompt-modal-dismissal-button",
                    className: (0, $esG4f.default)([
                        "_4cvr1h6o _4t3i1ejb _11q7glyw _19itglyw _1e0c1txw _1aax1b4t _2lx21bp4 _kqswh2mm _d0altlke _1ohh1qd8 _1ilwidpf _1bsb1ejb"
                    ]),
                    style: {
                        "--_1ex89o1": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark0"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f448m))), {
                        label: "close",
                        size: "medium"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_p12f12hx _1i4q1hna _y3gn1e5h _1e0c1ule _syaz1hlo"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                        className: (0, $esG4f.default)([
                            "_ect4bzd7 _1wybv47k _k48p1fw0 _vwz41f4h _18s8ze3t"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "genearl-signin-prompt.header.title",
                            defaultMessage: "You're logged out."
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_syaz1gjq _ect48q0o _1wyb7vkz _vwz41tcg _zg8l4jg8 _k48p1nn1"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "genearl-signin-prompt.header.subtext",
                            defaultMessage: "Log in to your account for a more personalized experience."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1q51pxbi"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gHCzX.AccountSignin), {
                    Input: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_frvh1p0d _ie4m1cjc"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvyIB.Input), {
                            labelText: intl.formatMessage({
                                id: "genearl-signin-prompt.email-label",
                                defaultMessage: "Email"
                            }),
                            helpText: ""
                        })
                    }),
                    Login: null,
                    Social: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "general-signin-prompt-social-wrapper",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $81Ns6.Social), {
                            providers: {
                                google: "Google",
                                microsoft: "Microsoft"
                            }
                        })
                    }),
                    Submit: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "general-signin-prompt-submit-wrapper",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $c6z6g.Submit), {
                            buttonText: intl.formatMessage({
                                id: "genearl-signin-prompt.login-button",
                                defaultMessage: "Log in"
                            })
                        })
                    })
                })
            })
        ]
    });
};
const $a7010b2471d28280$export$6b94dec1be0ad04b = ({ isUseGeneralSigninPromptConfig: isUseGeneralSigninPromptConfig = false, setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig })=>{
    return isUseGeneralSigninPromptConfig && /*#__PURE__*/ (0, $loA2J.jsx)($a7010b2471d28280$export$39e854c35d636741, {
        setIsUseGeneralSigninPromptConfig: setIsUseGeneralSigninPromptConfig
    });
};
$a7010b2471d28280$export$6b94dec1be0ad04b.displayName = "GeneralSigninPrompt";
var $a7010b2471d28280$export$2e2bcd8739ae039 = $a7010b2471d28280$export$6b94dec1be0ad04b;

});
parcelRegister("gHCzX", function(module, exports) {

$parcel$export(module.exports, "AccountSignin", function () { return $02cdc199600681b0$export$a388ecbea8ea27a1; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $6oKbD = parcelRequire("6oKbD");

var $4kWD7 = parcelRequire("4kWD7");

var $g9XgL = parcelRequire("g9XgL");

var $7bCRh = parcelRequire("7bCRh");

var $cvyIB = parcelRequire("cvyIB");

var $5KX8o = parcelRequire("5KX8o");

var $81Ns6 = parcelRequire("81Ns6");

var $c6z6g = parcelRequire("c6z6g");
const $02cdc199600681b0$var$AccountSigninContent = ({ Submit: Submit = /*#__PURE__*/ (0, $loA2J.jsx)((0, $c6z6g.Submit), {}), Input: Input = /*#__PURE__*/ (0, $loA2J.jsx)((0, $cvyIB.Input), {}), Social: Social = /*#__PURE__*/ (0, $loA2J.jsx)((0, $81Ns6.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $loA2J.jsx)((0, $4kWD7.Separator), {}), Error: Error = /*#__PURE__*/ (0, $loA2J.jsx)((0, $7bCRh.Error), {}), Login: Login = /*#__PURE__*/ (0, $loA2J.jsx)((0, $5KX8o.Login), {}) })=>{
    const { onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA } = (0, $g9XgL.useAccountSigninContext)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
                onSubmit: onSubmitWithReCAPTCHA,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                        autoComplete: "off",
                        "data-testid": "account-signin",
                        children: [
                            Input,
                            Submit
                        ]
                    }))
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};
const $02cdc199600681b0$export$a388ecbea8ea27a1 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g9XgL.AccountSigninContextProvider), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)($02cdc199600681b0$var$AccountSigninContent, (0, $7Knp0._)({}, props))
    });
};

});
parcelRegister("g9XgL", function(module, exports) {

$parcel$export(module.exports, "useAccountSigninContext", function () { return $d67f2badb2785751$export$2c59dd2afee36b71; });
$parcel$export(module.exports, "AccountSigninContextProvider", function () { return $d67f2badb2785751$export$8e536810811eea25; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eZAyW = parcelRequire("eZAyW");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $gkhN4 = parcelRequire("gkhN4");

var $jbZl4 = parcelRequire("jbZl4");

var $lrVTP = parcelRequire("lrVTP");
function $d67f2badb2785751$var$trackFormSubmit(createAnalyticsEvent) {
    const ajcbGrsData = (0, $jbZl4.getGrsDataFromLocalStorage)();
    const recoSessionId = ajcbGrsData === null || ajcbGrsData === void 0 ? void 0 : ajcbGrsData.recoSessionId;
    const recoEntityId = ajcbGrsData === null || ajcbGrsData === void 0 ? void 0 : ajcbGrsData.recoEntityId;
    createAnalyticsEvent({
        eventName: "gwp.formCloudSignIn.submitWithCaptcha",
        eventType: "ui",
        action: "clicked",
        actionSubject: "linkButton",
        actionSubjectId: "GenearlSigninPromptSubmitWithCaptcha",
        attributes: {
            recoSessionId: recoSessionId,
            recoEntityId: recoEntityId
        }
    }).fire();
}
function $d67f2badb2785751$var$trackContinueWithSocialSignin(createAnalyticsEvent, type) {
    const ajcbGrsData = (0, $jbZl4.getGrsDataFromLocalStorage)();
    const recoSessionId = ajcbGrsData === null || ajcbGrsData === void 0 ? void 0 : ajcbGrsData.recoSessionId;
    const recoEntityId = ajcbGrsData === null || ajcbGrsData === void 0 ? void 0 : ajcbGrsData.recoEntityId;
    createAnalyticsEvent({
        eventName: "gwp.formCloudSignIn.socialButtonClick",
        eventType: "ui",
        action: "clicked",
        actionSubject: "linkButton",
        actionSubjectId: "GenearlSigninPromptSocialButtonClick",
        attributes: {
            socialProvider: type,
            recoSessionId: recoSessionId,
            recoEntityId: recoEntityId
        }
    }).fire();
}
const $d67f2badb2785751$export$b9c683feff8b5c21 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $d67f2badb2785751$export$2c59dd2afee36b71 = ()=>{
    const context = (0, $iSvIT.useContext)($d67f2badb2785751$export$b9c683feff8b5c21);
    if (!context) throw new Error("useAccountSigninContext must be used within an AccountSigninContextProvider");
    return context;
};
const $d67f2badb2785751$export$8e536810811eea25 = ({ children: children })=>{
    const location = (0, $lrVTP.useLocation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [isEmailValid, setIsEmailValid] = (0, $iSvIT.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $iSvIT.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const [formError, setFormError] = (0, $iSvIT.useState)(false);
    const [_email, setEmail] = (0, $iSvIT.useState)("");
    const [typeAheadEmail, setTypeAheadEmail] = (0, $iSvIT.useState)("");
    const [onSubmitProps, setOnSubmitProps] = (0, $iSvIT.useState)(undefined);
    const [recaptchaFailedToLoad, setRecaptchaFailedToLoad] = (0, $iSvIT.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $iSvIT.useState)(60);
    const signupClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eZAyW.useGoogleReCaptcha)();
    const onSubmitWithReCAPTCHA = (0, $iSvIT.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            createAnalyticsEvent({
                eventName: "gwp.formCloudSignIn.submitFailureInvalidEmail",
                eventType: "ui",
                action: "submitted",
                actionSubject: "modal",
                actionSubjectId: "GeneralSigninPromptSubmitFailureInvalidEmail",
                attributes: {
                    event: "submitFailed"
                }
            }).fire();
            return;
        }
        setEmail(email);
        setOnSubmitProps({
            email: email
        });
        setIsSubmitting(true);
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setFormError(true);
            setIsSubmitting(false);
            setRecaptchaFailedToLoad(true);
            return;
        }
        setRecaptchaFailedToLoad(false);
        const gRecaptchaResponse = await (0, $jgJpJ.getRecaptcha)(email, executeRecaptcha);
        (0, $jgJpJ.ufoEventAccountSignin).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "AccountSigninContextProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            createAnalyticsEvent({
                eventName: "gwp.formCloudSignIn.submitFailureRecaptcha",
                eventType: "ui",
                action: "submitted",
                actionSubject: "modal",
                actionSubjectId: "GeneralSigninPromptSubmitFailureRecaptcha",
                attributes: {
                    event: "submitFailed"
                }
            }).fire();
            const invalidRecaptchaError = new Error("Missing reCAPTCHA token");
            (0, $jgJpJ.ufoEventAccountSignin).failure({
                customData: {
                    reactComponent: "AccountSigninContextProvider"
                },
                error: invalidRecaptchaError
            });
            throw invalidRecaptchaError;
        }
        $d67f2badb2785751$var$trackFormSubmit(createAnalyticsEvent);
        const existingUserRedirectUrl = await (0, $jgJpJ.getMethodsAvailableRedirection)({
            email: email,
            application: "wac",
            signupClient: signupClient,
            createAnalyticsEvent: createAnalyticsEvent,
            successRedirect: location.href
        }).catch((error)=>{
            setFormError(true);
            setIsSubmitting(false);
            createAnalyticsEvent({
                eventName: "gwp.formCloudSignIn.getMethodsAvailableRedirection.submitFailure",
                eventType: "ui",
                action: "submitted",
                actionSubject: "modal",
                actionSubjectId: "getMethodsAvailableRedirectionFormSubmitFailed",
                attributes: {
                    event: "submitFailed"
                }
            }).fire();
            throw new Error(error);
        });
        if (existingUserRedirectUrl) window.location.assign(existingUserRedirectUrl.replace("/initiate/password", ""));
        else window.location.assign(`${(0, $jgJpJ.getIdentityBaseUrl)()}/login?login_hint=${email}&prompt=none&continue=${location.href}`);
        return;
    }, [
        createAnalyticsEvent,
        executeRecaptcha,
        isEmailValid,
        recaptchaRetryTimeRemainingSecond,
        signupClient
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) (0, $jgJpJ.ufoEventAccountSignin).failure({
            customData: {
                reactComponent: "AccountSigninContextProvider",
                recaptchaRetryTimeRemainingSecond: 0
            },
            error: new Error("Recaptcha retry failed")
        });
        if (onSubmitProps && recaptchaFailedToLoad && executeRecaptcha) onSubmitWithReCAPTCHA(onSubmitProps).then(()=>{
            (0, $jgJpJ.ufoEventAccountSignin).success({
                customData: {
                    reactComponent: "AccountSigninContextProvider",
                    analyticsEvent: "succeeded",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            setFormError(true);
            (0, $jgJpJ.ufoEventAccountSignin).failure({
                customData: {
                    reactComponent: "AccountSigninContextProvider",
                    analyticsEvent: "errored",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        }).finally(()=>{
            setIsSubmitting(false);
        });
    }, [
        executeRecaptcha,
        recaptchaFailedToLoad,
        onSubmitProps,
        onSubmitWithReCAPTCHA,
        recaptchaRetryTimeRemainingSecond
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    const resetClickCountLogic = (0, $iSvIT.useCallback)(()=>{
        // Click action on Signin Prompt CTA resets click count logic
        localStorage.setItem("general_signin_prompt_x_clicks", "0");
        localStorage.setItem("general_signin_prompt_last_visit_timestamp", new Date().toISOString());
    }, []);
    const onClickSocialButton = (0, $iSvIT.useCallback)((provider)=>{
        $d67f2badb2785751$var$trackContinueWithSocialSignin(createAnalyticsEvent, provider);
        const socialRedirectUrl = (0, $jgJpJ.getSocialButtonUrl)({
            redirectTo: location.href,
            identityCobranding: "wac",
            provider: provider
        });
        resetClickCountLogic();
        window.location.assign(socialRedirectUrl);
    }, [
        createAnalyticsEvent,
        location.href,
        resetClickCountLogic
    ]);
    const onClickSubmitButton = (0, $iSvIT.useCallback)(()=>{
        resetClickCountLogic();
        return createAnalyticsEvent({
            eventName: "gwp.accountSignin.onclickSubmit",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "GenearlSigninPromptCtaSubmit"
        }).fire();
    }, [
        createAnalyticsEvent,
        resetClickCountLogic
    ]);
    const contextValue = (0, $iSvIT.useMemo)(()=>({
            formError: formError,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA,
            redirectTo: location.href,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail
        }), [
        formError,
        isReadyForInvalid,
        isSubmitting,
        onClickSocialButton,
        onClickSubmitButton,
        onSubmitWithReCAPTCHA,
        location.href,
        typeAheadEmail
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($d67f2badb2785751$export$b9c683feff8b5c21.Provider, {
        value: contextValue,
        children: children
    });
};

});

parcelRegister("7bCRh", function(module, exports) {

$parcel$export(module.exports, "Error", function () { return $322dc85f2cf8fd34$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $g9XgL = parcelRequire("g9XgL");
const $322dc85f2cf8fd34$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $f6qj2.default)();
    const { formError: formError } = (0, $g9XgL.useAccountSigninContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === "en" ? formatMessage({
        id: "gwp.accountSignin.userSignupError",
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $322dc85f2cf8fd34$var$contactUsLink
    }) : formatMessage({
        id: "gwp.accountSignin.formError",
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $322dc85f2cf8fd34$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        role: "alert",
        className: (0, $esG4f.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $322dc85f2cf8fd34$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $322dc85f2cf8fd34$var$errorCss = null;

});

parcelRegister("cvyIB", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $5f0a8303b124039d$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $26kkA = parcelRequire("26kkA");

var $bDTBs = parcelRequire("bDTBs");

var $1EpFI = parcelRequire("1EpFI");

var $7OGW4 = parcelRequire("7OGW4");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");

var $g9XgL = parcelRequire("g9XgL");
const $5f0a8303b124039d$var$HELP_TEXT_ID = "account_signin_email_help_text";
const $5f0a8303b124039d$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $g9XgL.useAccountSigninContext)();
    const [email, setEmail] = (0, $iSvIT.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $iSvIT.useState)();
    const intl = (0, $f6qj2.default)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: "gwp.accountSignin.helperText",
        defaultMessage: "Using a work email helps find teammates and boost collaboration."
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: "gwp.accountSignin.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: "gwp.accountSignin.workEmail",
        defaultMessage: "Work email"
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: "gwp.accountSignin.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    (0, $iSvIT.useEffect)(()=>{
        const isValid = (0, $jgJpJ.emailIsValid)(email); // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_6rth7vkz _1rwq121t _1heubzd7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rnbzd7 _1q9pbfng _d78pglyw"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_zbay183y",
                        isValid === true && "_1lo61ea4",
                        isValid === false && "_1lo611jk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({}, fieldProps), {
                            autoComplete: "on",
                            "aria-describedby": $5f0a8303b124039d$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsx)($5f0a8303b124039d$export$f8fea9f50a4bfae6, {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        })),
                        isValid === false ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            id: $5f0a8303b124039d$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $esG4f.default)([
                                "_syazweb4 _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            id: $5f0a8303b124039d$var$HELP_TEXT_ID,
                            className: (0, $esG4f.default)([
                                "_syaz1io3 _1wybepq8 _vwz4bs82 _1pfhi2wt"
                            ]),
                            style: {
                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500")),
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $5f0a8303b124039d$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const validMessage = formatMessage({
        id: "gwp.accountSignin.validEmailIcon",
        defaultMessage: "Email is valid"
    });
    const invalidMessage = formatMessage({
        id: "gwp.accountSignin.invalidEmailIcon",
        defaultMessage: "Email is invalid"
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syazxawg"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
            label: validMessage,
            size: "medium"
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswucd5j _1wyb1syg _y4tiftgi _syazp84t"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1EpFI))), {
            label: invalidMessage,
            size: "medium"
        })
    });
};
const $5f0a8303b124039d$var$green600 = "#22A06B";
const $5f0a8303b124039d$var$red700 = "#C9372C";
const $5f0a8303b124039d$var$red600 = "#E2483D";
const $5f0a8303b124039d$var$errorMessageCss = null;
const $5f0a8303b124039d$var$helpTextCss = null;
const $5f0a8303b124039d$var$fieldCss = null;
const $5f0a8303b124039d$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $5ohHq.wacToken)("color.neutral.light0"),
    fontSize: (0, $jgJpJ.fontSize).md,
    paddingInlineEnd: 8
};
const $5f0a8303b124039d$var$iconValidCss = null;
const $5f0a8303b124039d$var$iconInvalidCss = null;
const $5f0a8303b124039d$var$inputCss = null;
const $5f0a8303b124039d$var$inputInvalidCss = null;
const $5f0a8303b124039d$var$inputValidCss = null;

});

parcelRegister("5KX8o", function(module, exports) {

$parcel$export(module.exports, "Login", function () { return $992c2259cf2f503b$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $lrVTP = parcelRequire("lrVTP");
const $992c2259cf2f503b$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: "gwp.signinForm.loginText",
        defaultMessage: "<logInLink>Log in</logInLink>"
    }, {
        logInLink: (text)=>$992c2259cf2f503b$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
        },
        children: loginText
    });
};
const $992c2259cf2f503b$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $jgJpJ.getLoginUrl)(location)
    });
const $992c2259cf2f503b$var$existingProductCss = null;

});

parcelRegister("81Ns6", function(module, exports) {

$parcel$export(module.exports, "Social", function () { return $809c1172cfac5234$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $fYPhW = parcelRequire("fYPhW");

var $g9XgL = parcelRequire("g9XgL");
const $809c1172cfac5234$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $f6qj2.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $g9XgL.useAccountSigninContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    const buttonGridCss = null;
    const buttonListCss = null; /* eslint-disable jsx-a11y/no-redundant-roles */ 
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        role: "list",
        className: (0, $esG4f.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fYPhW.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signin",
                        defaultMessage: "sign in with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fYPhW.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};

});

parcelRegister("c6z6g", function(module, exports) {

$parcel$export(module.exports, "Submit", function () { return $bdb907cb5be16cfe$export$2c4cf1f7b42ef78c; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $g9XgL = parcelRequire("g9XgL");
const $bdb907cb5be16cfe$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $f6qj2.default)();
    const { isSubmitting: isSubmitting, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $g9XgL.useAccountSigninContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "gwp.accountSignin.submit",
        defaultMessage: "Log in"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || formError,
        isFullWidth: true,
        isLoading: isSubmitting || formError,
        onClick: onClickSubmitButton,
        children: buttonText
    });
};

});





parcelRegister("ejJ2S", function(module, exports) {
$parcel$export(module.exports, "analyticsLabels", function () { return (parcelRequire("cdfGl")).analyticsLabels; });
$parcel$export(module.exports, "GlobalNavUserProfile", function () { return (parcelRequire("cdfGl")).GlobalNavUserProfile; });
parcelRequire("cdfGl");

});


//# sourceMappingURL=direct-buy-org-setup-container.df682288.js.map
